import { createVNode as n, mergeProps as o } from "vue";
import l from "../node_modules/@pf-ui/pf-icon-svg/es/asn/PrintOutlined.js";
import m from "../components/PfIcon.js";
const t = (r, e) => {
  const i = {
    ...r,
    ...e.attrs
  };
  return n(m, o(i, {
    icon: l
  }), null);
};
t.displayName = "PrintOutlined";
t.inheritAttrs = !1;
export {
  t as default
};
